module.exports = function() {
  return new Worker(__webpack_public_path__ + "513aea5b15ca4898e173.worker.js");
};